export default "__VITE_ASSET__Bk8K9HDG__"